

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"}, rest), ["\n\t", h('path', {"fill":"currentColor","d":"M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"}, []), "\n"]);
};

        